class HeaderMenu {
  constructor() {
    this.hamburgerButton = document.querySelector('.nav-header-expand')
    this.nav = document.querySelector('.nav-header nav')
    this.overlay = document.querySelector('.nav-header-overlay')
    this.openMenu = document.getElementById('open-menu')
    this.closeMenu = document.getElementById('close-menu')
    this.navMobile = this.overlay.querySelector('nav')
  }

  toggleMenu() {
    this.nav.classList.toggle('is-open')
    const isOpen = this.nav.classList.contains('is-open')

    if (isOpen) {
      this.openMenu.classList.add('hidden')
      this.closeMenu.classList.remove('hidden')
      this.overlay.classList.remove('hidden')
      // eslint-disable-next-line no-unused-expressions
      this.overlay.offsetHeight

      // Animate to visible state
      this.overlay.classList.remove('opacity-0')
      this.overlay.classList.add('opacity-100')
      this.navMobile.classList.add('opacity-100', 'translate-y-0')
      this.navMobile.classList.remove('-translate-y-full')

      setTimeout(() => {
        this.navMobile.classList.remove('opacity-0')
      }, 100)
    } else {
      this.closeMenu.classList.add('hidden')
      this.openMenu.classList.remove('hidden')

      // Animate to hidden state
      this.overlay.classList.remove('opacity-100')
      this.overlay.classList.add('opacity-0')
      this.navMobile.classList.remove('opacity-100', 'translate-y-0')
      this.navMobile.classList.add('opacity-0', '-translate-y-full')

      setTimeout(() => {
        this.overlay.classList.add('hidden')
      }, 300)
    }

    document.body.classList.toggle('overflow-hidden', isOpen)
  }

  mount() {
    if (this.hamburgerButton) {
      this.hamburgerButton.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleMenu()
      })
    }
  }
}

export default HeaderMenu
